<template>
	<div class="body">
		<div class="body-container" v-if="data">

			<div class="title-ctr">{{data.title}}</div>

			<div class="step-ctr">
				<div class="step-name">{{data.step}}</div>
				<div class="step-route" @click="clickRule(data.ruleRoute)">{{data.ruleRoute.name}}</div>
			</div>

			<div class="factor-ctr">
				<label class="factor-name">{{data.adjustData.title}}</label>

				<el-button class="el-button--success select-major" type="primary" icon="el-icon-edit"
					@click="clickEditStandard">{{data.adjustData.name}}</el-button>

				<label class="factor-note">{{data.adjustData.tips}}</label>
			</div>

			<div class="table-title">分专业表</div>
			<el-table :data="majorTargetList" border stripe :span-method="spanMethod">
				<el-table-column label="专业" align="center" prop="major_name" />
				<el-table-column label="年份" align="center" prop="year" />
				<el-table-column label="需求人数" align="center" prop="employee_high" />
				<el-table-column label="供给人数" align="center" prop="supply_num" />
				<el-table-column label="供需差值" align="center" prop="diff_num" />
				<el-table-column label="适配率" align="center" prop="rate" />
				<el-table-column label="适配状态" align="center" prop="result" />
			</el-table>

			<div class="table-title">汇总表</div>
			<el-table :data="allList" border stripe>
				<el-table-column label="年份" align="center" prop="year" />
				<el-table-column label="需求人数" align="center" prop="employee_high" />
				<el-table-column label="供给人数" align="center" prop="supply_num" />
				<el-table-column label="供需差值" align="center" prop="diff_num" />
				<el-table-column label="适配率" align="center" prop="rate" />
				<el-table-column label="适配状态" align="center" prop="result" />
			</el-table>
		</div>

		<div class="action-ctr">
			<el-button type="primary" icon="el-icon-right" size='medium' @click="clickNext()"
				class="next-btn">导出数据</el-button>
				
			<el-button type="primary" icon="el-icon-s-marketing" size='medium' @click="clickReport()"
				class="next-btn el-button--success">数据解读</el-button>
		</div>

		<el-dialog title="编辑适配度标准" :visible.sync="showStandardDialog" append-to-body v-if="showStandardDialog"
			align="center">

			<div class="standard-ctr">
				<div class="row-item" v-for="(item, index) in standardList" :key="index">
					<div class="row-name">{{item.name}}</div>

					<!-- 修复：使用计算属性或直接绑定到对象属性 -->
					<div class="row-value-ctr" v-if="item.min !== undefined">
						<div class="row-operator">大于等于</div>
						<el-input class="row-input" :value="getMinValue(item.type)"
							@input="val => updateMinValue(item.type, val)" type="number" :step="step"></el-input>
					</div>

					<div class="row-value-ctr" v-if="item.max !== undefined">
						<div class="row-operator">小于</div>
						<el-input class="row-input" :value="getMaxValue(item.type)"
							@input="val => updateMaxValue(item.type, val)" type="number" :step="step"></el-input>
					</div>
				</div>
			</div>

			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickConfirmStandard()">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="原理介绍" :visible.sync="showIntroDialog" append-to-body v-if="showIntroDialog" align="center">

			<div class="rich-ctr">
				<div class="rich-value" v-html="introDialog.value"></div>
			</div>


			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickCloseIntroDialog()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getMatchCompare,
		getMatchStandard,
		updateMatchStandard,
		exportMajorMatch,
		getMajorMatchDownloadUrl
	} from "@/api/service"

	import {
		getSpanMap,
		isEmpty
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Famous",
		data() {
			return {
				params: {
					page: 1,
					pageSize: 20
				},
				spanMap: {},
				data: null,
				list: null,
				allList: null,
				majorTargetList: null,
				standardList: [],
				standardValueMap: {},
				showStandardDialog: false,
				step: 0.01,
				updateFactor: '',
				showIntroDialog: false,
				introDialog: null,
				variableType: {
					File: 2,
					Rich: 3
				}
			}
		},
		created() {
			this.initPageData();
		},

		methods: {
			initPageData() {
				this.params['id'] = this.$route.query.id;
				this.requestData();
			},

			buildParams() {
				return this.params;
			},

			requestData() {
				getMatchCompare(this.buildParams()).then(res => {
					let realData = res.data;
					this.data = realData;
					this.allList = res.data.allList;
					this.majorTargetList = res.data.majorTargetList;
					this.spanMap = getSpanMap(this.majorTargetList, ['major_name'])
				});
			},

			clickNext() {
				getMajorMatchDownloadUrl(this.params).then(res => {
					let realData = res.data;
				
					console.log('realData.url', realData.url)
					window.open(realData.url, '_blank')
				})
			},
			
			clickReport() {
				let path = '/match_report?id=' + this.params['id']
				this.$router.push(path);
			},


			clickRule(route) {
				if (route.type == this.variableType.File) {
					let path = route.path;
					window.open(path, '_blank')
				} else if (route.type == this.variableType.Rich) {
					this.showIntroDialog = true;
					this.introDialog = route;
				}
			},

			clickCloseIntroDialog() {
				this.showIntroDialog = false;
			},

			spanMethod({
				row,
				column,
				rowIndex
			}) {
				const colProp = column.property // 当前列字段名
				if (this.spanMap[colProp]) {
					const rowspan = this.spanMap[colProp][rowIndex]
					return {
						rowspan,
						colspan: rowspan === 0 ? 0 : 1
					}
				}
				return {
					rowspan: 1,
					colspan: 1
				}
			},

			clickEditStandard() {
				getMatchStandard(this.buildParams()).then(res => {
					let realData = res.data;
					this.showStandardDialog = true;
					this.standardList = realData.list;

					this.standardList.forEach((item, index, array) => {
						if (!this.standardValueMap[item['type']]) {
							this.$set(this.standardValueMap, item.type, {});
						}

						if (item.min !== undefined) {
							this.$set(this.standardValueMap[item.type], 'min', item.min);
						}

						if (item.max !== undefined) {
							this.$set(this.standardValueMap[item.type], 'max', item.max);
						}
					})
				})
			},

			clickConfirmStandard() {
				if (!this.validateRanges()) {
					Message({
						message: '标准数据区间不连续',
						type: 'error',
						zIndex: 300000
					})
					return;
				}

				let params = {
					'id': this.params['id'],
					'standardMap': JSON.stringify(this.standardValueMap)
				};

				updateMatchStandard(params).then(res => {
					this.showStandardDialog = false;
					this.requestData();
				})
			},

			outFactorChange(e) {
				console.log(e)
			},

			// 获取最小值
			getMinValue(type) {
				let value = this.standardValueMap[type]?.min;
				return value;
			},

			// 获取最大值
			getMaxValue(type) {
				let value = this.standardValueMap[type]?.max;
				return value;
			},

			// 更新最小值（使用 $set 确保响应式）
			updateMinValue(type, value) {
				console.log('updateMinValue type', type, 'value', value)
				// 处理空值
				const numValue = value === '' || value === null || value === undefined ?
					undefined :
					Number(value);

				this.$set(this.standardValueMap[type], 'min', numValue);
			},

			// 更新最大值（使用 $set 确保响应式）
			updateMaxValue(type, value) {
				console.log('updateMaxValue type', type, 'value', value)
				// 处理空值
				const numValue = value === '' || value === null || value === undefined ?
					undefined :
					Number(value);

				this.$set(this.standardValueMap[type], 'max', numValue);
			},

			// 验证区间连续性
			validateRanges() {
				// 按 type 顺序验证
				const types = ['serious', 'shortage', 'balance', 'surplus'];
				let hasError = false;

				for (let i = 0; i < types.length - 1; i++) {
					const current = this.standardValueMap[types[i]];
					const next = this.standardValueMap[types[i + 1]];

					if (current?.max !== undefined && next?.min !== undefined) {
						if (current.max != next.min) {
							hasError = true;
						}
					}
				}

				return !hasError;
			},
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "compare.scss";
</style>